import { z } from "zod";

export const downloadSchema = z.object({
  url: z.string(),
});

export type ApiDownload = z.infer<typeof downloadSchema>;
